import { getFunctionBaseUrl } from './RestUrls';
import * as rest from './RestUtil';
import { IMonthValue } from '../util/DateUtils';
// import { numerusData } from '../test/numerusData';

export interface INumerusPeriod {
  from: number;
  to: number;
  year: number;
}

export interface INumerusSubDetails {
  value: number;
  weight: number;
}

export interface INumerusSubCat {
  fi: INumerusSubDetails;
  al: INumerusSubDetails;
  b2b: INumerusSubDetails;
}

export interface INumerusSubs {
  code: string;
  viewCode: string;
  name: string;
  unit: string;
  inputs: INumerusSubCat;
}

export interface INumerusInputs {
  code: string;
  name: string;
  subs: INumerusSubs[];
  catSums: any;
}

export interface INumerusDetails {
  val: number;
  kg: number;
  kpl: number;
}

export interface INumerusTotals {
  fi: INumerusDetails;
  al: INumerusDetails;
  b2b: INumerusDetails;
}

export interface INumerusData {
  period: INumerusPeriod[];
  inputs: INumerusInputs[];
  totals: INumerusTotals;
}

export interface IRecyclingFeeReportSchedule {
  dayOfMonth: number;
  hour: number;
  minute: number;
}

export interface IRecyclingFeeReport {
  report_id: string;
  report_period: string;
  total_fi_recycling_fee: string;
  total_fi_pom_weight: string;
  total_al_recycling_fee: string;
  total_al_pom_weight: string;
}

export const getRecyclingFeeReports = async (startDate: string, endDate: string) => {
  const url = `${getFunctionBaseUrl()}/api/recycleFeeReports/${startDate}/${endDate}`;
  const response = await rest.get(url);
  return response as IRecyclingFeeReport[];
}

export const getNumerusData = async (params: INumerusPeriod) => {
  // if (true) { // For testing without backend...
  //   return numerusData.data as INumerusData;
  // }
  const url = `${getFunctionBaseUrl()}/api/getNumerus`;
  const response = await rest.get(url, params);
  return response.data as INumerusData;
}

const getDate = (reportingMonth: IMonthValue) => {
  const month = reportingMonth.month + 1;
  const monthStr = month < 10 ? '0' + month : month;
  return `${reportingMonth.year}-${monthStr}`;
}

export const getSavedNumerusData = async (reportingMonth: IMonthValue) => {
  const date = getDate(reportingMonth);
  const url = `${getFunctionBaseUrl()}/api/NumerusDataInsert/${date}`;
  const response = await rest.get(url);
  return response;
}

export const saveNumerusData = async (reportingMonth: IMonthValue, data: INumerusData) => {
  const date = getDate(reportingMonth);
  const url = `${getFunctionBaseUrl()}/api/NumerusDataInsert/${date}`;
  const response = await rest.post(url, data);
  return response;
}

export const getRecyclingFeeSchedule = async () => {
  const url = `${getFunctionBaseUrl()}/api/recycleFeeSchedule`;
  const response = await rest.get(url);
  return response as IRecyclingFeeReportSchedule;
}

export const saveRecyclingFeeSchedule = async (schedule: IRecyclingFeeReportSchedule) => {
  const url = `${getFunctionBaseUrl()}/api/recycleFeeSchedule`;
  const response = await rest.put(url, schedule);
  return response;
}
